import type { FragmentType } from 'src/gql';
import type { Deprecated_HandleItemUpdate } from 'src/types/account';
import { useState } from 'react';
import { UpdateType } from 'src/constants/portfolio';
import { graphql, unmaskFragment } from 'src/gql';
import { LIABILITY_DELETE_BUTTON_TEXT, LIABILITY_DELETION_TEXT } from 'src/utils/liability';

import { useMutationWithErrorLogging } from '@savvy/graphql-hooks/useMutationWithErrorLogging';

import RemoveItemDialog from '../views/remove-item-dialog';
import PortfolioLiabilityDescriptionRow from './portfolio-liability-description-row';

export const RemoveLiabilityDialogFragment = graphql(/* GraphQL */ `
  fragment RemoveLiabilityDialog on Liability {
    ...PortfolioLiabilityDescriptionRow
    id
  }
`);

const DELETE_LIABILITY = graphql(/* GraphQL */ `
  mutation DeleteLiability($input: DeleteLiabilityInput!) {
    deleteLiability(input: $input) {
      success
    }
  }
`);

export default function RemoveLiabilityDialog({
  liabilityFrag,
  onRemove,
  onClose,
}: {
  readonly liabilityFrag: FragmentType<typeof RemoveLiabilityDialogFragment>;
  readonly onRemove: Deprecated_HandleItemUpdate;
  readonly onClose: () => void;
}) {
  const liability = unmaskFragment(RemoveLiabilityDialogFragment, liabilityFrag);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteLiability] = useMutationWithErrorLogging(DELETE_LIABILITY);

  const handleDeleteClick = async () => {
    setIsLoading(true);
    await deleteLiability({
      variables: {
        input: {
          id: liability.id,
        },
      },
    });

    setIsLoading(false);
    onRemove({
      type: UpdateType.DELETE_LIABILITY,
      id: liability.id,
    });
  };

  return (
    <RemoveItemDialog
      descriptionRow={<PortfolioLiabilityDescriptionRow liabilityFrag={liability} />}
      deleteButtonText={LIABILITY_DELETE_BUTTON_TEXT}
      deletionText={LIABILITY_DELETION_TEXT}
      isLoading={isLoading}
      onClose={onClose}
      onRemove={handleDeleteClick}
    />
  );
}
